// src/Components/PortfolioItem.js
import React from 'react';

const PortfolioItem = ({ title, description, imageUrl, linkUrl, tags }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-xl border border-gray-200">
      <img
        src={imageUrl}
        alt={title}
        className="w-full h-48 object-cover object-center"
        onError={(e) => { e.target.onerror = null; e.target.src = '[https://placehold.co/600x400/CCCCCC/333333?text=Image+Not+Available](https://placehold.co/600x400/CCCCCC/333333?text=Image+Not+Available)'; }}
      />
      <div className="p-6">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        <div className="flex flex-wrap gap-2 mb-4">
          {tags && tags.map((tag, index) => (
            <span key={index} className="bg-gray-100 text-gray-700 text-sm font-medium px-2 py-1 rounded-full">
              {tag}
            </span>
          ))}
        </div>
        {linkUrl && (
          <a
            href={linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-blue-600 text-white font-bold py-2 px-6 rounded-full shadow-md hover:bg-blue-700 transition-colors duration-300"
          >
            Visit Website &rarr;
          </a>
        )}
      </div>
    </div>
  );
};

export default PortfolioItem;